var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnhanceBlueE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "270px",
    height: "270px",
    viewBox: "0 0 270 270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.399,124.319 C138.233,124.319 124.319,138.233 124.319,155.399 C124.319,172.564 138.233,186.478 155.399,186.478 C164.603,186.478 172.874,182.477 178.565,176.118 L267.479,176.118 C268.714,169.399 269.358,162.474 269.358,155.399 C269.358,148.323 268.714,141.398 267.479,134.679 C257.735,81.634 211.261,41.44 155.399,41.44 L155.399,0 C69.574,0 0,69.574 0,155.399 L41.44,155.399 C41.44,218.336 92.461,269.358 155.399,269.358 C195.404,269.358 230.595,248.744 250.929,217.558 L192.773,217.558 C181.859,224.135 169.071,227.918 155.399,227.918 C115.347,227.918 82.88,195.45 82.88,155.399 L41.44,155.399 C41.44,92.461 92.461,41.44 155.399,41.44 L155.399,82.879 C188.25,82.879 216,104.723 224.915,134.679 L178.565,134.679 C172.874,128.32 164.603,124.319 155.399,124.319",
    id: "Fill-1",
    fill: "#00BED9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceBlueE);
export default __webpack_public_path__ + "static/media/enhance_blue_e.7ed3cb7d41752ac8b889e4e5dd4f0001.svg";
export { ForwardRef as ReactComponent };